export default "__VITE_ASSET__bu_Rjt8V__"